import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { res } from '../../../common/language/text/res';
import { Organization } from '../../../common/model/Organization';
import { UnsoldItemSizeDto } from '../../../common/model/dto/UnsoldItemSizeDto';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { UnsoldItemSizeFacade } from '../../../common/facade/UnsoldItemSizeFacade';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { DatePipe } from '@angular/common';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { Strings } from '../../../common/language/strings';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { AlertComponent } from 'ngx-bootstrap/alert';

@Component({
  selector: 'app-unsold-item-size',
  templateUrl: './unsold-item-size.component.html',
  styleUrls: ['./unsold-item-size.component.css']
})
export class UnsoldItemSizeComponent implements OnInit {

  titleUnsoldItemSize = res.UnsoldItemSize;
    lblSearch = res.Search;
    lblStore = res.Store;
    lblDescription = res.Description;
    lblStyleVariety = res.StyleVariety;
    lblSizeName = res.Size;
    lblDate = res.Date;
    lblHour = res.Hour;
    
    lblSelectAnOption = res.SelectAnOption;
    
    lblStartDate = res.StartDate;
    lblEndDate = res.EndDate;
    lblDownload = res.Download;
    lblOrganization = res.Organization;
  
    errorSmallerThan = res.SmallerDateThan;
    errorGreaterThan = res.GreaterDateThan;
  
    public txtMinDate = new Date(this.getNowUTC().getFullYear() - 1,
      this.getNowUTC().getMonth(),
      1,
      this.getNowUTC().getHours(),
      this.getNowUTC().getMinutes(),
      this.getNowUTC().getSeconds(),
      this.getNowUTC().getMilliseconds());
    public txtMaxDate = this.getNowUTC();
    public txtStartDate = new Date();
    public txtEndDate = new Date();
    lstOrganization: Organization[] = [];
    selectedOrganizations: Organization[] = [];
    availableOrganizations: Organization[] = [];
    public organizationSelected: any[] = [];
    strOrganizationSelected: string;
    organizationId: string;
  
    isSpanish = true;
  
    messagesTable: any = {
      emptyMessage: '',
      totalMessage: ''
    };
  
    rowCountInvId = '';
    rowCodeItem = '';
  
    loading = false;
    messageLoader = '';
    // alert
    alertsFileExcel = [];
    generalAlerts = [];
    // table
    rows: UnsoldItemSizeDto[];
    private _filteredData: UnsoldItemSizeDto[];
    // filters
    store = -1;
    tmpStore = -1;
    stores = [];
    // minDate = new Date();
    fecha = new Date();
    tenantId: number = -1;
    stringSelectedOrganizations: string = '';
  
    constructor(
      @Inject(SESSION_STORAGE) private _storage: WebStorageService,
      private _router: Router,
      private _unsoldItemSizeFacade: UnsoldItemSizeFacade,
      private _facadeStore: StoreFacade,
      private _route: ActivatedRoute,
      public datepipe: DatePipe,
      private _excel: ExcelUtility,
      public strings: Strings,
      private localeService: BsLocaleService
    ) {
      this._storage.set('moduleUrl', this._router.url);
    }
  
    ngOnInit() {
      this.isSpanish = this.strings.getLanguageIsSpanish();
      this.localeService.use(this.strings.getLanguage());
  
      this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
      this.messagesTable.totalMessage = 'Total';
  
      this.tenantId = this.strings.getTenant();
      this.lstOrganization = this.strings.getAvailableOrganizations().filter(x => x.tenantId == this.tenantId);
  
      this._route.queryParams.subscribe(params => {
        if (params['startDate'] !== undefined && params['endDate'] !== undefined) {
          this.txtStartDate = new Date(params['startDate']);
          this.txtEndDate = new Date(params['endDate']);
          this.txtMaxDate = new Date(params['endDate']);
        }
  
        if (params['orgId'] !== undefined) {
          this.organizationId = params["orgId"];
          this.strOrganizationSelected = this.organizationId;
          this.organizationSelected = this.lstOrganization.filter((org) =>
            this.organizationId.includes(org.organizationId)
          );
          this.selectedOrganizations = this.lstOrganization;
          this.getStores();
          this.getUnsoldItemSizeByOrganizationDates();
        }
  
        if (params['storeId'] !== undefined || params['storeId'] !== -1) {
          this.store = params['storeId']
          this.rows = this._filteredData.filter(item => {
            return (item.storeId.toString() === this.store.toString());
          });
        }
      });
    }
  
    private getNowUTC() {
      const now = new Date();
      return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
    }
  
    private getStores() {
      this.messageLoader = this.strings.GetText(res.Loading);
      this.stores = [];
      if (this.selectedOrganizations.length > 0) {
        this._facadeStore.GetParticipateQuantum().subscribe(
          response => {
            const stores = response.data;
            if (stores.length > 0) {
              stores.forEach(store => {
                if (this.selectedOrganizations.find(organization => organization.organizationId == store.organizationId) != undefined)
                  this.stores.push(store);
              });
            }
          }, error => {
            this.loading = false;
            this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertStoresCouldNotBeObtained), 'danger', 'general');
          }
        );
        this.store = this.store !== -1 && this.store > 0 ? this.store : -1;
      }
    }
    // añadir alert
    addAlert(message: String, type: String, fileType: String) {
      if (fileType === 'excel') {
        this.alertsFileExcel = [];
        this.alertsFileExcel.push({
          type: type,
          msg: message
        });
      } else {
        this.generalAlerts = [];
        this.generalAlerts.push({
          type: type,
          msg: message
        });
      }
  
    }
  
    // cerrar alert
    onClosed(dismissedAlert: AlertComponent, fileType: String): void {
      if (fileType === 'excel') {
        this.alertsFileExcel = this.alertsFileExcel.filter(alert => alert !== dismissedAlert);
      } else {
        this.generalAlerts = this.generalAlerts.filter(alert => alert !== dismissedAlert);
      }
    }
  
    // filters
    updateFilter(event) {
      // get the value of the key pressed and make it lowercase
      const val = event.target.value.toLowerCase();
      // get the key names of each column in the dataset
      const keys = Object.keys(this._filteredData[0]);
      // assign filtered matches to the active datatable
      this.rows = this._filteredData.filter(function (item) {
        // iterate through each row's column data
        for (let i = 0; i < keys.length; i++) {
          if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
            return true;
          }
        }
      });
    }
  
    onStoreChange() {
      this.fecha = new Date();
  
      if (this.store.toString() === '-1') {
          this.rows = this._filteredData;
      } else {
          this.rows = this._filteredData.filter(item => {
            return (item.storeId.toString() === this.store.toString());
          });
      }
      this.loading = false;
    }
  
    downloadReport() {
      this.loading = true;
      this.messageLoader = this.strings.GetText(res.Loading);

      if (this.rows.length > 0) {
        const data: any = [];
        this.rows.forEach((row) => {
          const info = {
            [this.strings.GetText(res.Store)]: row.storeName,
            [this.strings.GetText(res.Description)]: row.description,
            [this.strings.GetText(res.Style) + " " + this.strings.GetText(res.Variety)]: row.styleVariety,
            [this.strings.GetText(res.Size)]: row.sizeName,
            [this.strings.GetText(res.Date)]: this.datepipe.transform(row.insertedDate, 'dd-MM-yyyy'),
            [this.strings.GetText(res.Hour)]: this.datepipe.transform(row.insertedDate,  'HH:mm:ss a')
          };
          data.push(info);
        });
        this._excel.exportAsExcelFile(data, "UnsoldItemSize");
        this.loading = false;
      } else {
        this.addAlert(
          this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile),
          "danger", "excel"
        );
        this.loading = false;
      }
    }

    onChangeStartDate(value) {
      this.txtStartDate = this.subtractTimeFromDate(value, 6);
    }
  
    onChangeEndDate(value) {
      this.txtEndDate = this.subtractTimeFromDate(value, 6);
    }
  
    getUnsoldItemSizeByOrganizationDates() {
      this.loading = this.loading ? true : true;
      this._filteredData = [];
  
      if (this.selectedOrganizations.length == 0) {
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertSelectOrganization), 'danger', 'general');
        this.loading = false;
        return;
      } else {
        this.stringSelectedOrganizations = this.lstOrganization.map(o => o.organizationId).join(',');
      }
  
      if (new Date(this.txtStartDate) > new Date(this.txtEndDate)) {
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger', 'general');
        this.loading = false;
      } else {
        let language = 0;
        if (!this.isSpanish) {
          language = 1;
        }
        this._unsoldItemSizeFacade.GetCollectionUnsoldItemSizeByOrganizationDates(this.organizationId, this.datepipe.transform(this.txtStartDate, 'yyyyMMdd_HH:mm:ss') + '.000',
          this.datepipe.transform(this.txtEndDate, 'yyyyMMdd_HH:mm:ss') + '.000', language).subscribe(
            response => {
              this.rows = response.data;
              if (response.data.length > 0) {
                this._filteredData = response.data;
              }

              this.onStoreChange();
  
              this.loading = false;
            }, error => {
              this.loading = false;
              this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertInventoriesCouldNotBeObtained), 'danger', 'general');
            }
          );
      }
    }
  
    onChangeOrganization(selected: Organization[]) {
      this.selectedOrganizations = selected;
      this.strOrganizationSelected = this.selectedOrganizations
        .map((e) => e.organizationId)
        .join(",");
        this.organizationId = this.strOrganizationSelected;
      this.getStores();
    }
  
    search() {
      this.getUnsoldItemSizeByOrganizationDates();
    }
  
    subtractTimeFromDate(objDate, intHours) {
      var numberOfMlSeconds = objDate.getTime();
      var addMlSeconds = intHours * 60 * 60000;
      var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
      return newDateObj;
    }
  }
  